export default function(record, commit) {
    if (record.provider.endsWith(':message')) {
		commit('provider/removeMessage')
	}
	else if (record.provider.endsWith(':schedule')) {
		commit('provider/removeSchedule')
	}
}
